/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserRegisterInputDto { 
    emailAddress?: string | null;
    countryCode: string;
    phoneNumber: string;
    fullName?: string | null;
    readonly surname?: string | null;
    readonly middleName?: string | null;
    readonly name?: string | null;
}

